// extracted by mini-css-extract-plugin
module.exports = {"layoutSwitcherItem":"ideaLayoutSwitcher_layoutSwitcherItem__14FLy","icon":"ideaLayoutSwitcher_icon__PlnK2","active":"ideaLayoutSwitcher_active__Im8_W"};